import { render, staticRenderFns } from "./LifestyleEventsReport.vue?vue&type=template&id=54c7b0e8&scoped=true"
import script from "./LifestyleEventsReport.ts?vue&type=script&lang=ts&external"
export * from "./LifestyleEventsReport.ts?vue&type=script&lang=ts&external"
import style0 from "./LifestyleEventsReport.scss?vue&type=style&index=0&id=54c7b0e8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7b0e8",
  null
  
)

export default component.exports